import { NamedError } from "../utils/Errors";

export class TranscriptionSourceFileError extends NamedError<TranscriptionSourceFileErrors> {}

export enum TranscriptionSourceFileErrors {
    SourceFileNotFound = "SourceFileNotFound"
}